import axios from "axios";

const API = process.env.REACT_APP_API_URL;

export async function incrementMetric({
  sessionCode,
  stage,
  playerId,
  metricKey,
  delta = 1,
  meta,
}) {
  try {
    const token = localStorage.getItem("token");

    const res = await axios.post(
      `${API}/api/metrics/increment`,
      {
        sessionCode,
        stage,
        playerId,
        metricKey,
        delta,
        meta,
      },
      {
        headers: token ? { Authorization: `Bearer ${token}` } : undefined,
        withCredentials: false,
      }
    );

    return res.data;
  } catch (err) {
    // On évite de casser le jeu si l’API est down : log seulement
    const status = err?.response?.status;
    const data = err?.response?.data;
    console.warn("[metrics] increment failed:", status, data || err.message);
    return null;
  }
}

export function trackError({ sessionCode, stage, playerId, reason, meta }) {
  return incrementMetric({
    sessionCode,
    stage,
    playerId,
    metricKey: "errors",
    delta: 1,
    meta: { reason, ...(meta || {}) },
  });
}

export function trackTimeLost({ sessionCode, stage, playerId, seconds }) {
  return incrementMetric({
    sessionCode,
    stage,
    playerId,
    metricKey: "time_lost",
    delta: seconds,
  });
}


export function trackTaquinMoves({ sessionCode, stage, playerId, moves }) {
  const n = Number(moves);

  return incrementMetric({
    sessionCode,
    stage,
    playerId,
    metricKey: "taquin_moves",
    delta: Number.isFinite(n) ? n : 0,
  });
}

export function trackInteraction({ sessionCode, stage, playerId, objectId }) {
  console.log("[INTERACTIONS] +1", { sessionCode, stage, playerId, objectId });
  return incrementMetric({
    sessionCode,
    stage,
    playerId,
    metricKey: `interactions`,
    delta: 1,
    meta: objectId ? { objectId } : undefined,
  });
}

export function trackHintUsed({ sessionCode, stage, playerId, level, hintId }) {
  const metricKey =
    level === "l1" ? "hints_l1" :
      level === "l2" ? "hints_l2" :
        level === "l3" ? "hints_l3" :
          level === "answer" ? "hints_answer" :
            "hints_l1";

  return incrementMetric({
    sessionCode,
    stage,
    playerId,
    metricKey,
    delta: 1,
  });
}
